export default __webpack_public_path__ + "static/media/Shopify.43acf083.svg";